'use strict';

var react = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var isFunction = require('@userzoomlibraries/toolkit-js-utils/is-function');
var noop = require('@userzoomlibraries/toolkit-js-utils/noop');
var promisify = require('@userzoomlibraries/toolkit-js-utils/promisify');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);
var isFunction__default = /*#__PURE__*/_interopDefaultCompat(isFunction);
var noop__default = /*#__PURE__*/_interopDefaultCompat(noop);
var promisify__default = /*#__PURE__*/_interopDefaultCompat(promisify);

var _excluded = ["async"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useAsyncHandlers = function useAsyncHandlers() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$async = _ref.async,
      async = _ref$async === void 0 ? true : _ref$async,
      callbacks = _objectWithoutProperties(_ref, _excluded);

  var initialState = Object.keys(callbacks).reduce(function (acc, current) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, current, false));
  }, {});

  var _useState = react.useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var asyncHandlers = Object.keys(callbacks).reduce(function (acc, callbackName) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, callbackName, _defineProperty({
      isLoading: state[callbackName]
    }, callbackName, function () {
      if (isFunction__default["default"](callbacks[callbackName])) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (async) {
          setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, callbackName, true)));
          var callbackToExecute = callbacks[callbackName];

          if (callbackToExecute === noop__default["default"] || callbackToExecute === function () {}) {
            callbackToExecute = function callbackToExecute(event, callback) {
              callback();
            };
          }

          var promisifiedCallback = promisify__default["default"](callbackToExecute);
          promisifiedCallback(args)["finally"](function () {
            setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, callbackName, false)));
          });
        } else {
          callbacks[callbackName].apply(callbacks, args);
        }
      }
    })));
  }, {});
  return asyncHandlers;
};

useAsyncHandlers.HOOK_ID = 'Gearz.ReactHooks.useAsyncHandlers';
useAsyncHandlers.returnType = PropTypes__default["default"].shapeWithDescription({
  CALLBACK_NAME: PropTypes__default["default"].shapeWithDescription({
    isLoading: PropTypes__default["default"].boolWithDescription('Flag to check if the callback is executing.'),
    CALLBACK_NAME: PropTypes__default["default"].funcWithDescription('Callback transformed into async function.')
  }, 'Handler name. (onClick, onChange, etc...)')
}, 'Object of async handlers.');
useAsyncHandlers.parameterTypes = {
  async: PropTypes__default["default"].boolWithDescription('Flag to make the callbacks async.'),
  CALLBACK_NAME: PropTypes__default["default"].funcWithDescription('Callback to transform into async. (onClick, onChange, etc...)').isRequired
};
useAsyncHandlers.defaultParameters = {
  async: true
};

module.exports = useAsyncHandlers;
